export default __webpack_public_path__ + "static/media/agreement.0bbcd3e1.svg";